import { useSyncExternalStore } from 'react';
import { throttle } from 'lodash';

const breakpoints = {
  extraSmall: 480,
  small: 768,
  medium: 1023,
  large: 1200,
  extraLarge: 1600,
};

let lastSnapshot = null;
let lastKey = null;
let mediaQueries = null;

const getMediaQueries = () => {
  if (mediaQueries) {
    return mediaQueries;
  }

  mediaQueries = {
    extraSmall: window.matchMedia(`(max-width: ${breakpoints.extraSmall - 1}px)`),
    small: window.matchMedia(`(min-width: ${breakpoints.extraSmall}px) and (max-width: ${breakpoints.small - 1}px)`),
    medium: window.matchMedia(`(min-width: ${breakpoints.small}px) and (max-width: ${breakpoints.medium - 1}px)`),
    large: window.matchMedia(`(min-width: ${breakpoints.medium}px) and (max-width: ${breakpoints.large - 1}px)`),
    extraLarge: window.matchMedia(`(min-width: ${breakpoints.large}px) and (max-width: ${breakpoints.extraLarge - 1}px)`),
    infinity: window.matchMedia(`(min-width: ${breakpoints.extraLarge}px)`),
  };

  return mediaQueries;
};

const getSnapshot = () => {
  const queries = getMediaQueries();
  const is = {
    extraSmall: queries.extraSmall.matches,
    small: queries.small.matches,
    medium: queries.medium.matches,
    large: queries.large.matches,
    extraLarge: queries.extraLarge.matches,
    infinity: queries.infinity.matches,
  };
  const key = Object.values(is).join();

  if (lastSnapshot && lastKey === key) {
    return lastSnapshot;
  }

  lastKey = key;
  lastSnapshot = {
    width: window.innerWidth,
    is,
  };

  return lastSnapshot;
};

const subscribe = (callback) => {
  const throttledCallback = throttle(callback, 150);
  const queries = Object.values(getMediaQueries());

  window.addEventListener('resize', throttledCallback);
  queries.forEach((query) => query.addEventListener('change', throttledCallback));

  return () => {
    window.removeEventListener('resize', throttledCallback);
    queries.forEach((query) => query.removeEventListener('change', throttledCallback));
    throttledCallback.cancel?.();
  };
};

export const useBrowser = () => {
  return useSyncExternalStore(
    subscribe,
    getSnapshot,
    () => ({ width: 1200, is: { large: true } })
  );
};
